import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import PermanentDrawerLeft from "./components/drawer/drawer";
import SSEManager from "./components/profileDetails/seeManager";
import Profile from "./components/profileDetails/profileDetails";
import { useTrackStatus } from "./components/kitchen/fetchOrderKitchen";
import SSEProvider from "./components/waiterOrder/SSEProvider";
import { UnsavedChangesProvider } from "./components/shared/UnsavedChangesGuard";

function AppShell() {
  useTrackStatus();
  return <UnsavedChangesProvider>
    <SSEManager />
    <SSEProvider />
    <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    <Outlet />
  </UnsavedChangesProvider>;
}
// Data-router blockers also protect Back/Forward and programmatic route navigation.
const router = createBrowserRouter([{ element: <AppShell />, children: [
  { path: "/", element: <PermanentDrawerLeft /> },
  { path: "/profile", element: <Profile /> },
] }]);
export default function App() { return <RouterProvider router={router} />; }
